module.exports = __webpack_public_path__ + "img/kommune-1127.f53ab4e2.svg";